export const getStage = () => {
  const env = process.env.NEXT_PUBLIC_ENVIRONMENT
  const stage = (() => {
    if (env === 'development') return 'dev-'
    if (env === 'staging') return 'staging-'
    return ''
  })()
  return stage
}
